<!-- src/App.vue
     Shell wrapper controls theming and prevents footer cutoff.
-->
<template>
  <div :class="['app-shell', themeClass]">
    <a href="#main" class="skip-link">Naar inhoud</a>

    <SiteHeader />

    <main id="main" class="app-main" tabindex="-1">
      <router-view />
    </main>

    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from '@/components/layout/SiteHeader.vue'
import SiteFooter from '@/components/layout/SiteFooter.vue'

export default {
  name: 'App',
  components: { SiteHeader, SiteFooter },
  computed: {
    // Adds either .theme-finance or .theme-spiritual on the shell,
    // which flips fonts/colors as a backup to the body[data-section] hook.
    themeClass () {
      return this.$route?.meta?.section === 'spiritual'
          ? 'theme-spiritual'
          : 'theme-finance'
    }
  }
}
</script>

<style>
/* The shell makes sure the footer never overlaps or gets cut off */
.app-shell {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.app-main {
  flex: 1 0 auto;
}
.app-main:focus {
  outline: none; /* it only receives focus via the skip link */
}

/* Skip link: off-screen until it receives keyboard focus */
.skip-link {
  position: fixed;
  left: 12px;
  top: 12px;
  z-index: 200;
  transform: translateY(-150%);
  background: var(--surface);
  color: var(--brand);
  border: 1px solid var(--brand);
  border-radius: 10px;
  padding: 8px 14px;
  font-weight: 700;
  box-shadow: var(--shadow-md);
  transition: transform .15s ease;
}
.skip-link:focus {
  transform: translateY(0);
}
@media (prefers-reduced-motion: reduce) {
  .skip-link { transition: none; }
}
</style>
